module.exports = {"url":"https://employee-schedule-11883.firebaseio.com"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 309
// module chunks = 0